export default "TRUK";
